import { useCallback, useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "@/shared/lib/cn";

const SLIDES = [
  { src: "/login1.png", alt: "Safecheck — illustration connexion 1" },
  { src: "/login2.png", alt: "Safecheck — illustration connexion 2" },
  { src: "/login3.png", alt: "Safecheck — illustration connexion 3" },
] as const;

const AUTOPLAY_MS = 5000;

export function LoginCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);

  const goTo = useCallback((index: number) => {
    setActiveIndex((index + SLIDES.length) % SLIDES.length);
  }, []);

  const goNext = useCallback(() => goTo(activeIndex + 1), [activeIndex, goTo]);
  const goPrev = useCallback(() => goTo(activeIndex - 1), [activeIndex, goTo]);

  useEffect(() => {
    const timer = window.setInterval(goNext, AUTOPLAY_MS);
    return () => window.clearInterval(timer);
  }, [goNext]);

  return (
    <div className="relative h-full w-full overflow-hidden">
      {SLIDES.map((slide, index) => (
        <img
          key={slide.src}
          src={slide.src}
          alt={slide.alt}
          className={cn(
            "absolute inset-0 h-full w-full object-cover transition-opacity duration-700 ease-in-out",
            index === activeIndex ? "opacity-100" : "opacity-0",
          )}
        />
      ))}

      <div className="absolute inset-0 bg-gradient-to-br from-sidebar-bg/15 via-sidebar-bg/5 to-sidebar-bg/10" />

      <div className="absolute inset-x-0 bottom-8 flex items-center justify-center gap-2 px-6">
        {SLIDES.map((slide, index) => (
          <button
            key={slide.src}
            type="button"
            onClick={() => goTo(index)}
            aria-label={`Afficher l'image ${index + 1}`}
            className={cn(
              "h-2 rounded-full transition-all duration-300",
              index === activeIndex ? "w-8 bg-accent" : "w-2 bg-white/40 hover:bg-white/60",
            )}
          />
        ))}
      </div>

      <button
        type="button"
        onClick={goPrev}
        aria-label="Image précédente"
        className="absolute left-4 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-black/25 text-white backdrop-blur-sm transition-colors hover:bg-black/40"
      >
        <ChevronLeft size={20} />
      </button>
      <button
        type="button"
        onClick={goNext}
        aria-label="Image suivante"
        className="absolute right-4 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-black/25 text-white backdrop-blur-sm transition-colors hover:bg-black/40"
      >
        <ChevronRight size={20} />
      </button>
    </div>
  );
}
